// **** import modules ****
// pm modules
import { Klass, csl, u_ } from "@pressmedia/webappbase";
import * as google from "@pressmedia/google";


// **** process ****
csl.on("log");
csl.on("warn");

const initArgs = [];
const config = JSON.parse(APP_INFO);
if(config.name) {
	initArgs.push(config.name);
	delete config.name;
}

if( u_.isObject(config.rootDir) ) {
	if(location.hostname === "localhost") {
		config.rootDir.dev = location.host;
	}
	initArgs.push(config.rootDir);
	delete config.rootDir;
}

// app init
const app = Klass.new_("WebAppBase", ...initArgs);
if(!app.config.rootdir) {
	app.setRootDir(location.host);
	app._environment = "dev";
}

if(config.title) {
	app.title = config.title;
	!document.title && (document.title = config.title);
	delete config.title;
}

if(app._environment === "prod") {
	delete csl.colors.grey;
	csl._attachColors("log", false);
	
	const gconfig = JSON.parse(GCONFIG);
	// GA
	if( u_.isObject(gconfig.analytics) && gconfig.analytics.trackingID ) {
		google.loadGA(gconfig.analytics.trackingID, false, () => {
			csl.log.grey("loadGA -- success.");
		});
		app.gaAutoSendPageview = true;
	}
	
	// GTM
	if( u_.isObject(gconfig.tagMameger) && gconfig.tagMameger.containerID ) {
		google.loadGTM(gconfig.tagMameger.containerID, () => {
			csl.log.grey("loadGTM -- success.");
		});
	}
	
	config.google = gconfig;
}

Object.assign(app.config, config);

// polyfill for IE
app.promiseForPolyfill = new Promise(resolve => {
	const list = [];
	!window.fetch && list.push("fetch");
	if(list.length) {
		const features = encodeURIComponent( list.join(",") );
		const qs = u_.createQueryString({ features });
		const s = document.createElement("script");
		s.src = `https://polyfill.io/v3/polyfill.min.js${qs}`;
		s.onload = resolve;
		s.onerror = resolve;
		document.head.appendChild(s);
	} else {
		resolve();
	}
});

// export to window
Object.assign(window, {
	app,
	Klass,
	csl,
	u_
});

export default app;
export { Klass, csl, u_ };
